const getSavedCalculatorDataWithOutputUrl = require("./getSavedCalculatorDataWithOutputUrl");
const submitRoiCalculator1233Form = require("./submitRoiCalculator1233Form");

/**
 * @param outputUrl {string}
 * @return {void}
 */
module.exports = async function submitRoiCalculator1233FormWithOutputUrl(outputUrl) {
    const calculatorData = getSavedCalculatorDataWithOutputUrl(outputUrl);
    if (calculatorData) {
        await submitRoiCalculator1233Form(calculatorData);
    } else {
        console.error("Could not find calculator data");
    }
}